import "./_dropdown.scss";

import cx from "classnames";
import {ReactNode} from "react";
import {useState} from "react";

function Dropdown({
  children,
  titre = "",
  complementTitre = "",

  defaultOpen = false,
}: {
  children?: ReactNode;
  titre: string;
  complementTitre: JSX.Element | string;

  defaultOpen: boolean;
}): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  const handleClick = (): void => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className={cx("dropdown", isOpen && "open")}>
      <div className="dropdown-header" onClick={handleClick}>
        <h4>
          {titre} {complementTitre}
        </h4>
        <div className={cx("triangle-code", isOpen && "reverse")}></div>
      </div>
      <div className="dropdown-content">{children}</div>
    </div>
  );
}

export default Dropdown;
